//import images from 'assets/images/images';
import Product from 'components/home/Product'
import { useRequest } from 'hooks/useRequest'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import Slider from 'react-slick'
import { setCategories, setFilterProducts } from 'redux/product/productSlice'
import auth from 'utils/Auth'
import { Helmet } from 'react-helmet'
import InfiniteScroll from 'react-infinite-scroll-component'
import ApprovalModal from 'components/approvalModal/ApprovalModal'
import BasketCardDrawer from 'containers/basketCardDrawer/BasketCardDrawer'
import { toast } from 'react-toastify'
import { getAllBasketFunc } from 'redux/features/general/generalSlice'
import useTranslate from 'hooks/useTranslate'
import Breadcrumbs from 'components/Breadcrumbs'
import { dataLayerPush } from 'utils/Datalayer'

const ProductCategory = () => {
	const [getCategories] = useRequest() //update işlemi yapalım.Bu sekilde cok karısıyor burası...
	const [request] = useRequest()
	const [pageRequest] = useRequest()
	const [firstpageRequest, firstPageReqLoading] = useRequest()
	const { product } = useSelector((state) => state)
	const { categoryList, productFilterList } = product
	const dispatch = useDispatch()
	const { id } = useParams()
	const [isOpenDrawer, setIsOpenDrawer] = useState(false)
	const [categoryDetail, setCategoryDetail] = useState({})
	const [singleDrawerProduct, setSingleDrawerProduct] = useState({ id: null, item: null })
	const [approvalModal, setApprovalModal] = useState({ open: false, order: null, type: null })
	const { t } = useTranslate()
	const inititialScrollOptions = {
		hasNextPage: false,
		pageIndex: 0,
		totalCount: 0,
		pageSize: 12,
	}
	const [scrollOptions, setScrollOptions] = useState(inititialScrollOptions)
	const settingsCategory = {
		//dots: true,
		infinite: true,
		speed: 1000,
		autoplay: false,
		autoplaySpeed: 3000,
		slidesToShow: categoryList?.length < 7 ? categoryList?.length : 7,
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: 1500,
				settings: {
					slidesToShow: 6,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 1180,
				settings: {
					slidesToShow: 5,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 3,
					initialSlide: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
				},
			},
		],
		nextArrow: (
			<svg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<g id='chevron-right'>
					<path
						id='Path (Stroke)'
						fillRule='evenodd'
						clipRule='evenodd'
						d='M23.2322 8.23223C24.2085 7.25592 25.7915 7.25592 26.7678 8.23223L56.7678 38.2322C57.7441 39.2085 57.7441 40.7915 56.7678 41.7678L26.7678 71.7678C25.7915 72.7441 24.2085 72.7441 23.2322 71.7678C22.2559 70.7915 22.2559 69.2085 23.2322 68.2322L51.4645 40L23.2322 11.7678C22.2559 10.7915 22.2559 9.20854 23.2322 8.23223Z'
						fill='#96004B'
					/>
				</g>
			</svg>
		),
		prevArrow: (
			<svg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<g id='chevron-left'>
					<path
						id='Path (Stroke)'
						fillRule='evenodd'
						clipRule='evenodd'
						d='M56.7678 8.23223C57.7441 9.20854 57.7441 10.7915 56.7678 11.7678L28.5355 40L56.7678 68.2322C57.7441 69.2085 57.7441 70.7915 56.7678 71.7678C55.7915 72.7441 54.2085 72.7441 53.2322 71.7678L23.2322 41.7678C22.2559 40.7915 22.2559 39.2085 23.2322 38.2322L53.2322 8.23223C54.2085 7.25592 55.7915 7.25592 56.7678 8.23223Z'
						fill='#96004B'
					/>
				</g>
			</svg>
		),
	}

	useEffect(() => {
		window.scrollTo(0, 0)
		getCategories('/Catalog/Categories', {
			method: 'GET',
			headers: {
				restaurantId: auth.getUserChoises()?.restaurantId,
				deliveryType: auth.getUserChoises()?.deliveryType,
				neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
				regionId: auth.getUserChoises()?.regionId,
			},
		}).then((res) => {
			if (res.data.ok) {
				dispatch(setCategories(res.data.result))
			}
		})
	}, [])

	useEffect(() => {
		request(`/Catalog/Category/${id}`, {
			method: 'GET',
			headers: {
				restaurantId: auth.getUserChoises()?.restaurantId,
				deliveryType: auth.getUserChoises()?.deliveryType,
				neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
				regionId: auth.getUserChoises()?.regionId,
			},
		}).then((res) => {
			if (res.data.ok) {
				setCategoryDetail(res.data.result)
			}
		})
	}, [id])

	useEffect(() => {
		setScrollOptions(inititialScrollOptions)
	}, [id])
	useEffect(() => {
		if (scrollOptions.pageIndex == inititialScrollOptions.pageIndex && categoryDetail?.id) {
			firstpageRequest(`/Catalog/Products`, {
				method: 'GET',
				headers: {
					restaurantId: auth.getUserChoises()?.restaurantId,
					deliveryType: auth.getUserChoises()?.deliveryType,
					neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
					regionId: auth.getUserChoises()?.regionId,
				},
				params: {
					PageIndex: scrollOptions.pageIndex,
					PageSize: scrollOptions.pageSize,
					CategoryId: categoryDetail.id,
				},
			}).then((res) => {
				if (res.data.ok) {
					dispatch(setFilterProducts(res?.data?.result?.items))
					setScrollOptions((prev) => ({ ...prev, hasNextPage: res.data.result.hasNextPage }))
				}
				if (res?.data?.result?.items?.length > 0) {
						const items = res?.data?.result?.items || []
						dataLayerPush({ ecommerce: null })
						for (let start = 0; start < items.length; start += 3) {
							const chunk = items.slice(start, start + 3)
							dataLayerPush({
								event: 'view_item_list',
								ecommerce: {
									item_list_name: 'Listeleme Sayfası',
									currency: 'TRY',
									items: chunk.map((prev, i) => ({
										item_id: prev.id,
										item_name: prev.name,
										affilication: 'Tavuk Dünyası',
										discount: prev.discountAmount,
										index: start + i,
										item_brand: 'Tavuk Dünyası',
										item_category: prev.categories?.[0]?.value,
										item_category2: prev.categories?.[1]?.value ? prev.categories?.[1]?.value : '',
										item_category3: prev.categories?.[2]?.value ? prev.categories?.[2]?.value : '',
										item_list_name: 'Listeleme Sayfası',
										price: prev.price,
									})),
								},
							})
						}
					}
			})
		} else if (categoryDetail?.id) {
			pageRequest(`/Catalog/Products`, {
				method: 'GET',
				headers: {
					restaurantId: auth.getUserChoises()?.restaurantId,
					deliveryType: auth.getUserChoises()?.deliveryType,
					neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
					regionId: auth.getUserChoises()?.regionId,
				},
				params: {
					PageIndex: scrollOptions.pageIndex,
					PageSize: scrollOptions.pageSize,
					CategoryId: categoryDetail.id,
				},
			}).then((res) => {
				if (res.data.ok) {
					dispatch(
						setFilterProducts(
							scrollOptions.pageIndex == inititialScrollOptions.pageIndex
								? res?.data?.result?.items
								: [...productFilterList.concat(res?.data?.result?.items)]
						)
					)
					setScrollOptions((prev) => ({ ...prev, hasNextPage: res.data.result.hasNextPage }))
				}
			if(res?.data?.result?.items?.length > 0){
					const items = res?.data?.result?.items || []
					dataLayerPush({ ecommerce: null });
					for (let start = 0; start < items.length; start += 3) {
						const chunk = items.slice(start, start + 3)
						dataLayerPush({
							event:"view_item_list",
							ecommerce: {
								item_list_name: "Listeleme Sayfası",
								currency: "TRY",
								items: chunk.map((prev, i) => ({
									item_id: prev.id,
									item_name: prev.name,
									affilication: "Tavuk Dünyası",
									discount: prev.discountAmount,
									index: start + i,
									item_brand: "Tavuk Dünyası",
									item_category: prev.categories?.[0]?.value,
									item_category2: prev.categories?.[1]?.value ? prev.categories?.[1]?.value : "",
									item_category3: prev.categories?.[2]?.value ? prev.categories?.[2]?.value: "",
									item_list_name: "Listeleme Sayfası",
									price: prev.price
								}))
							}
						});
					}
				}	
			})
		}
	}, [scrollOptions.pageIndex, categoryDetail.id])
	const fetchNewFeed = async () => {
		if (scrollOptions.hasNextPage) {
			setScrollOptions((prev) => ({ ...prev, pageIndex: prev.pageIndex + 1 }))
		}
	}

	// useEffect(() => {
	//   if (!isOpenDrawer) {
	//     setProductCount(1)
	//   }
	// }, [isOpenDrawer])

	const clearBasket = () => {
		if (approvalModal.type == 'DELETE') {
			request(`/ShoppingCart/RemoveItem?id=${approvalModal.order.id}`, {
				method: 'POST',
				//data: {id : id},
				headers: {
					restaurantId: auth.getUserChoises()?.restaurantId,
					deliveryType: auth.getUserChoises()?.deliveryType,
					neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
					regionId: auth.getUserChoises()?.regionId,
				},
			}).then((res) => {
				if (res.data) {
					dispatch(getAllBasketFunc(res?.data?.result))
					toast.success(t('successfullToast', { type: t('delete'), name: '' }))
					setApprovalModal({ open: false, order: null, type: null })
				}
			})
		} else {
			request('/ShoppingCart/ClearCart', {
				method: 'POST',
				headers: {
					restaurantId: auth.getUserChoises()?.restaurantId,
					deliveryType: auth.getUserChoises()?.deliveryType,
					neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
					regionId: auth.getUserChoises()?.regionId,
				},
			}).then((res) => {
				if (res) {
					dispatch(getAllBasketFunc([]))
					setApprovalModal({ open: false, order: null, type: null })
				}
			})
		}
	}

	return (
		<div className='productCategory'>
			<Helmet>
				<title>{categoryDetail?.metaTitle || categoryDetail?.name}</title>
				{categoryDetail?.metaDescription && <meta name='description' content={categoryDetail?.metaDescription} />}
			</Helmet>
			<div className='home-category-slider'>
				<Breadcrumbs
					className={'breadcrumbs px-0'}
					breadcrumbList={[
						{ text: t('homePage'), link: '/' },
						{ text: categoryDetail?.name, link: '/' },
					]}
				/>
				<h1 className='header-m2'>{categoryDetail?.name}</h1>
				<Slider {...settingsCategory}>
					{categoryList?.map((category, i) => (
						<Link to={`/kategori/${category.url}`} key={i} className='home-category-slider-cont'>
							<img src={category?.imagePath} alt={category?.name} />
							<div>{category?.name}</div>
							{id == category?.url && <div className='activeCategory'></div>}
						</Link>
					))}
				</Slider>
			</div>
			<div className='home-products'>
				<InfiniteScroll
					dataLength={productFilterList.length}
					next={fetchNewFeed}
					hasMore={scrollOptions.hasNextPage}
					loader={
						<div className='home-products-container mt-4'>
							<div className='product'>
								<div className='skeleton skeleton-card-img' />
								<div className='skeleton skeleton-text' />
								<div className='skeleton skeleton-text' />
								<div className='skeleton skeleton-footer' />
							</div>
							<div className='product'>
								<div className='skeleton skeleton-card-img' />
								<div className='skeleton skeleton-text' />
								<div className='skeleton skeleton-text' />
								<div className='skeleton skeleton-footer' />
							</div>
							<div className='product'>
								<div className='skeleton skeleton-card-img' />
								<div className='skeleton skeleton-text' />
								<div className='skeleton skeleton-text' />
								<div className='skeleton skeleton-footer' />
							</div>
						</div>
					}
				>
					<div className='home-products-container'>
						{firstPageReqLoading && (
							<>
								<div className='product'>
									<div className='skeleton skeleton-card-img' />
									<div className='skeleton skeleton-text' />
									<div className='skeleton skeleton-text' />
									<div className='skeleton skeleton-footer' />
								</div>
								<div className='product'>
									<div className='skeleton skeleton-card-img' />
									<div className='skeleton skeleton-text' />
									<div className='skeleton skeleton-text' />
									<div className='skeleton skeleton-footer' />
								</div>
								<div className='product'>
									<div className='skeleton skeleton-card-img' />
									<div className='skeleton skeleton-text' />
									<div className='skeleton skeleton-text' />
									<div className='skeleton skeleton-footer' />
								</div>
							</>
						)}
						{productFilterList.length > 0 ? (
							productFilterList?.map((product, i) => (
								<Product
									isOpenDrawer={isOpenDrawer}
									setIsOpenDrawer={setIsOpenDrawer}
									setSingleDrawerProduct={setSingleDrawerProduct}
									key={i}
									product={product}
									componentName="list"
								/>
							))
						) : (
							<div className='category-warningMessage'>{t('productNotFound')}</div>
						)}
					</div>
				</InfiniteScroll>
			</div>

			<ApprovalModal
				onClose={approvalModal.open}
				title={approvalModal.type == 'DELETE' ? t('youRemoveOrderFromList') : t('youRemoveProductFromCard')}
				desc={approvalModal.type == 'DELETE' ? t('sureYouWantRemoveFromListOrder') : t('sureYouWantClearBasket')}
				closeModal={() => setApprovalModal({ open: false, order: null, type: null })}
				onApproval={clearBasket}
			/>

			<BasketCardDrawer
				isOpenDrawer={isOpenDrawer}
				setIsOpenDrawer={setIsOpenDrawer}
				singleDrawerProduct={singleDrawerProduct}
				setApprovalModal={setApprovalModal}
				setSingleDrawerProduct={setSingleDrawerProduct}
			/>
		</div>
	)
}

export default ProductCategory
